// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  position: fixed;
  display: flex;
  width: 100%;
  height: calc(100% - 62px);
  justify-content: center;
  align-items: center;
  left: 0;
  top: 62px;
}
:host .display {
  width: 500px;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
:host .display h3 {
  color: black;
  margin: 0;
}
:host .display p {
  margin: 0;
  color: #737373;
}
:host .display .circle {
  width: 350px;
  height: 350px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 2px 54px rgba(196, 196, 196, 0.4);
  border: 1px dashed #dbdbdb;
  display: flex;
  justify-content: center;
  align-items: center;
}
:host .display .circle cs-icon {
  width: 250px;
  height: 250px;
}
:host .display .no-projects-action {
  display: flex;
  justify-content: center;
  width: 100%;
}
:host .display .no-projects-action button {
  min-width: 200px;
}

@media (max-width: 1440px) {
  :host {
    height: calc(100% - 42px);
    top: 42px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
